import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const features = [
  {
    name: 'Ledelse der virker',
    description: 'Topscore i medarbejdertilfredshed (97/100). Mit fokus er på at skabe motivation, psykologisk tryghed og en tydelig retning for holdet.',
    icon: 'Users',
  },
  {
    name: 'Datadrevet udvikling',
    description: 'Beviselig succes med SEO, publikumsudvikling og implementering af nye forretningsmodeller baseret på solide data.',
    icon: 'TrendingUp',
  },
  {
    name: 'Sikker drift i højt tempo',
    description: 'Jeg mestrer balancen mellem ambitiøs forretningsudvikling og de daglige operationer, selv når deadlines er korte.',
    icon: 'Shield',
  },
];

const ValueProps = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-base text-slate-500 font-semibold tracking-wide uppercase">Hvorfor mig</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Fundamentet for redaktionel succes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {features.map((feature, index) => (
            <motion.div
              key={feature.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative p-8 bg-stone-50 rounded-2xl border border-stone-100 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="absolute top-8 left-8">
                <span className="flex items-center justify-center h-12 w-12 rounded-xl bg-slate-900 text-white shadow-sm">
                  <SafeIcon name={feature.icon} className="h-6 w-6" aria-hidden="true" />
                </span>
              </div>
              <div className="mt-16">
                <h3 className="text-xl font-bold text-slate-900 mb-4">{feature.name}</h3>
                <p className="text-base text-slate-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProps;